import React from 'react';
import LocalizedLink from 'components/LocalizedLink';
import WithlocalsLogoSmall from 'components/icons/WithlocalsLogoSmall';
import {isCordova} from "utils/platform";

function LinkLogo({ transparent }) {
  if (process.env.NODE_ENV === 'development' || isCordova()) {
    return (
      <LocalizedLink to="/" aria-label="Back to homepage">
        <WithlocalsLogoSmall width={48} height={32} color={transparent ? 'white' : '#8B174E'} />
      </LocalizedLink>
    );
  }

  return (
    <a href="/" aria-label="Back to homepage">
      <WithlocalsLogoSmall width={48} height={32} color={transparent ? 'white' : '#8B174E'} />
    </a>
  );
}

export default LinkLogo;
